import Model from "../classes/Model";
import Api from "../classes/api/Client";

export default class Debt extends Model {

    static STATUS_OPEN = 1;
    static STATUS_CLOSE = 2;

    get id() {
        return this._id;
    }

    set cashflowId(value) {
        this._cashflowId = value;
    }
    get cashflowId() {
        return this._cashflowId;
    }

    set status(value) {
        this._status = value;
    }
    get status() {
        return this._status;
    }

    set clientId(value) {
        this._clientId = value;
    }
    get clientId() {
        return this._clientId;
    }

    set clientSubscriptionId(value) {
        this._clientSubscriptionId = value;
    }
    get clientSubscriptionId() {
        return this._clientSubscriptionId;
    }

    set sumIn(value) {
        this._sumIn = value;
    }
    get sumIn() {
        return this._sumIn;
    }

    set debt(value) {
        this._debt = value;
    }
    get debt() {
        return this._debt;
    }

    set expireDate(value) {
        this._expireDate = value;
    }
    get expireDate() {
        return this._expireDate;
    }

    get createdAt() {
        return this._createdAt;
    }
    set createdAt(value) {
        this._createdAt = value;
    }
    get createdBy() {
        return this._createdBy;
    }
    set createdBy(value) {
        this._createdBy = value;
    }

    constructor (config) {
        super();

        for (let field in config) {
            if (config.hasOwnProperty(field) === false) {
                continue;
            }
            this[`_${field}`] = config[field];
        }
    }

    toRequest() {
        // return {
        //     client_id: this.clientId,
        // };
    }

    static toResponse(data) {
        return {
            id: data.id,
            cashflowId: data.cashflow_id,
            status: data.status,
            clientId: data.client_id,
            clientSubscriptionId: data.client_subscription_id,
            sumIn: data.sumIn,
            debt: data.debt,
            expireDate: data.expire_date,
            createdAt: data.created_at,
            createdBy: data.created_by,
        };
    }

    static getList(clientId) {
        return Api.getDebts(clientId).then((response) => {
            let data = [];
            for (let debts of response.data) {
                data.push(new this(this.toResponse(debts)));
            }
            return {data, headers: response.headers};
        });
    }

    close(paymentType, drop = false, comment = '') {
        return Api.debtClose(this.id, paymentType, drop, comment).then((response) => {
            return response.data.result;
        });
    }

}
